module.exports = __webpack_public_path__ + "img/YourCloud.d569b544.svg";